import "normalize.css"
import "./index.scss"

import { createRoot } from "react-dom/client"
import "focus-visible"
import App from "components/App/App"

import { i18nInit } from "./intl/i18n"

// browser API calls mocks
if (import.meta.env.VITE_API_MOCKS) {
    (async function() {
        const { worker } = await import("mocks/browser")
        await worker.start()
        run()
    })()
} else {
    run()
}

async function run() {
    /*
        Important: If you do any changes in the script below, make sure you make the same updates
        in the /public/index.html file
    */
    const userAgent = ((navigator && navigator.userAgent) || '').toLowerCase()

    if ((!isChrome()
        && !isFirefox()
        && !isOpera()
        && !isSafari()
        && !isEdgeChromium())
        || isEdge()
        || isUCBrowser()) {
        /* just stop execution to prevent any React scripts execution,
            because redirect to he /browser-not-supported.html should fire in the /index.html
        */
        return
    }

    function isChrome() {
        const match = userAgent.match(/(?:chrome|crios)\/(\d+)/)
        return match !== null && !isOpera() && !isEdgeChromium()
    }
    function isFirefox() {
        const match = userAgent.match(/(?:firefox|fxios)\/(\d+)/)
        return match !== null
    }
    function isOpera() {
        const match = userAgent.match(/(?:opr|opt)\/(\d+)/)
        return match !== null
    }
    function isSafari() {
        const match = userAgent.match(/version\/(\d+).+?safari/)
        return match !== null
    }
    function isEdgeChromium() {
        const match = userAgent.match(/(?:edg)\/(\d+)/)
        return match !== null && !isEdge()
    }
    function isEdge() {
        const match = userAgent.match(/(?:edge)\/(\d+)/)
        return match !== null
    }
    function isUCBrowser() {
        const match = userAgent.match(/(?:ucbrowser)\/(\d+)/)
        return match !== null
    }

    await i18nInit

    const container = document.getElementById("root")
    const root = createRoot(container!)
    root.render(<App />)
}
